import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TextareaAutoresizeDirective } from '@app/app/directives/textarea-autoresize.directive';
import { CreateMessageReply } from '@app/app/store/messages/messages.actions';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-add-message-reply',
  templateUrl: './add-message-reply.component.html',
  styleUrl: './add-message-reply.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    TextareaAutoresizeDirective,
  ],
})
export class AddMessageReplyComponent {
  dealId = input.required<number>();
  messageId = input.required<number>();

  isSaving = signal(false);
  replyAdded = output<void>();

  replyFormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(2000),
  ]);

  constructor(protected _store: Store) {}

  addReply(reply: string): void {
    this.isSaving.set(true);
    this._store
      .dispatch(
        new CreateMessageReply(
          this.dealId(),
          this.messageId(),
          reply
        )
      )
      .subscribe({
        complete: () => {
          this.isSaving.set(false);
          this.replyAdded.emit();
          this.replyFormControl.reset();
        },
        error: () => {
          this.isSaving.set(false);
          this.replyFormControl.setErrors({ serverError: true });
        },
      });
  }
}
